"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoReadyPickupSwap = void 0;
const typebox_1 = require("@sinclair/typebox");
const pricing_1 = require("../../pricing");
exports.RoReadyPickupSwap = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    prohibited_items_list: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    pickup_date: typebox_1.Type.String(),
    delivery_notes: typebox_1.Type.String(),
    dumpster_size: typebox_1.Type.String(),
    material: typebox_1.Type.String(),
    weight_limit: typebox_1.Type.String(),
    rental_period: typebox_1.Type.String(),
    overage_fee: typebox_1.Type.String(),
    price_type: pricing_1.TypeOfPricing,
    order_total: typebox_1.Type.String(),
    rental_extension_fee: typebox_1.Type.String(),
    payment_link: typebox_1.Type.String(),
});
//# sourceMappingURL=ro-ready-pickup-swap.js.map